/**
 * Decode a JWT payload on the client WITHOUT verifying the signature.
 * The backend still verifies the signature — this is only used to inspect
 * claims (e.g. `token_type`) so the FE can route to the correct endpoint.
 *
 * Returns the decoded payload object, or `null` if the token is malformed.
 */
export const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(escape(atob(padded)));

    return JSON.parse(json);
  } catch {
    return null;
  }
};
